// extracted by mini-css-extract-plugin
export var chevronIcon = "_cf-2";
export var teamName = "_cf-1";
export var teamSwitcherButton = "_cf-0";